"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageButtons = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireDefault(require("react"));
var _ReviewsButton = require("./ReviewsButton");
var _DeleteButton = require("./DeleteButton");
var _EditButton = require("./EditButton");
var _ReservationButton = require("./ReservationButton");
var _VisualizeButton = require("./VisualizeButton");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ImageButtons = function ImageButtons(props) {
  var product = props.product;
  var ReviewsButton = props.reviewsButtonComponent || _ReviewsButton.ReviewsButton;
  var VisualizeButton = props.visualizeButtonComponent || _VisualizeButton.VisualizeButton;
  var DeleteButton = props.deleteButtonComponent || _DeleteButton.DeleteButton;
  var EditButton = props.editButtonComponent || _EditButton.EditButton;
  var ReservationButton = props.reservationButtonComponent || _ReservationButton.ReservationButton;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ReviewsButton, {
    product: product
  }, function (_ref) {
    var onClick = _ref.onClick;
    return /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      onClick: onClick
    }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "star_rate"));
  }), /*#__PURE__*/_react.default.createElement(DeleteButton, _extends({}, props, {
    product: product
  }), function (_ref2) {
    var onClick = _ref2.onClick;
    return /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      color: "primary",
      onClick: onClick
    }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
      color: "error"
    }, "delete"));
  }), /*#__PURE__*/_react.default.createElement(EditButton, _extends({}, props, {
    product: product
  }), function (props) {
    return /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      color: "primary",
      onClick: props === null || props === void 0 ? void 0 : props.onClick
    }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
      color: "primary"
    }, "edit"));
  }), /*#__PURE__*/_react.default.createElement(ReservationButton, _extends({}, props, {
    product: product
  })), /*#__PURE__*/_react.default.createElement(VisualizeButton, _extends({}, props, {
    product: product
  }), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    color: "primary"
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    color: "action"
  }, "remove_red_eye"))), props.renderExtraActionsButtons && props.renderExtraActionsButtons(product));
};
exports.ImageButtons = ImageButtons;